import React, { useState, useEffect } from "react";
import Container from '@mui/material/Container';
import { Alert, Button, FormControl, Menu, MenuItem, Modal, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import { FaPlus } from "react-icons/fa";
import axios from "axios";
import Loadingspinner from "../../../components/Loadingspinner";
import { Deleteuserurl, Fetchaccountsurl } from "../../../utils/chaturls";
import Addagent from "./addagent";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import { MoreHorizOutlined } from "@mui/icons-material";
import { getsessionuser } from "../../../utils/sessions";
import Popupdialog from "../../../components/popupdialog";
import { primarycolor } from "../../../utils/colors";

const tableheadstyle = {
    color: "white",
    fontWeight: "bold"
}



const Agents = () => {

    const user = getsessionuser();
    const [refreshdata, setrefreshdata] = useState('');
    const [agents, setagents] = useState([]);
    const [displayedagents, setdisplayedagents] = useState([]);

    const [loading, setloading] = useState(true);
    const [error, seterror] = useState('');
    const [success, setsuccess] = useState('');

    const [tempuser, settempuser] = useState('');

    //modals
    const [showaddview, setshowaddview] = useState(false);
    const [showdeleteuser, setshowdeleteuser] = useState(false);

    const [agentname, setagentname] = useState('');
    const [agentid, setagentid] = useState();

    useEffect(() => {
        fetchagents()
    }, []);

    useEffect(() => {
        if (refreshdata !== 'default') {
            fetchagents()
            setshowaddview(false)
        }
    }, [refreshdata]);

    setInterval(() => {
        const userobject = sessionStorage?.getItem("agentmessage");
        const object = JSON.parse(userobject);
        if (object) {
            if (object?.message) {
                setrefreshdata(object.message)
            }
        }
    }, 2000);

    const fetchagents = async () => {
        setloading(true)
        axios.post(Fetchaccountsurl)
            .then(response => {
                setloading(false)
                if (!response.data.error) {
                    setagents(response.data)
                    setdisplayedagents(response.data)
                } else {
                    seterror(response.data.message)
                }
                // 
            }).catch(error => {
                setloading(false)
                seterror("Sorry an error occurred,try again later");
                //if(error.response.status === 401 || error.response.status === 400){}
            });
    }

    //delete user
    const deleteuser = () => {
        setshowdeleteuser(false)
        setloading(true)
        axios.post(Deleteuserurl, {
            userid: tempuser.id
        }).then(response => {
            setloading(false)
            if (!response.data.error) {
                setsuccess("Deleted successfully")
                setTimeout(() => {
                    fetchagents()
                    setsuccess()
                }, 3000);
            } else {
                seterror(response.data.message)
            }
            // 
        }).catch(error => {
            setloading(false)
            seterror("Sorry an error occurred,try again later");
            //if(error.response.status === 401 || error.response.status === 400){}
        });
    }


    const Searchlogic = () => {
        var result = [];
        agents.forEach(element => {
            if (element.id === parseInt(agentid) || (agentname && element.username?.toLowerCase().replace(/\s+/g, '').match(agentname?.toLowerCase().replace(/\s+/g, '')))) {
                result.push(element)
            }
        });
        return result;
    }

    //search agents
    const searchagents = () => {
        if (!agentid && !agentname) {
            setdisplayedagents(agents)
        } else {
            const gottendata = Searchlogic()
            if (gottendata.length > 0) {
                setdisplayedagents(gottendata)
            } else {
                setdisplayedagents([])
                seterror("no agents matches the search query")
            }
        }
    }
    //onsuccess
    const onsuccess = () => {
        setshowaddview(false)
        fetchagents()
    }

    //dismiss modals
    const ondismiss = () => {
        setshowaddview(false)
    }


    return (
        <div>
            <Snackbar open={error?.length > 0 && true} autoHideDuration={3000} onClose={() => seterror()}>
                <Alert severity="error">{error}</Alert>
            </Snackbar>
            <Snackbar open={success?.length > 0 && true} autoHideDuration={3000} onClose={() => setsuccess()}>
                <Alert severity="success">{success}</Alert>
            </Snackbar>
            {loading && <Loadingspinner />}
            {showaddview && <Addagent onsuccess={onsuccess} ondismiss={ondismiss} />}
            {showdeleteuser &&
                <Popupdialog
                    toptext={"Confirm Deletion!"}
                    question={"Are you sure you want to delete this user?"}
                    oncancel={() => setshowdeleteuser(false)}
                    onsuccess={deleteuser}
                    successtext={"Delete"} />
            }
            <div className="routepathwrap">
                <div className="routepathmain">Accounts </div>
                <div className="routepathminor"> {` `}/ Agents</div>
            </div>

            <Container maxWidth="lg" className="containerwithshadow">
                <div style={{ display: "flex" }}>
                    <TextField
                        id="outlined-basic"
                        value={agentid}
                        onChange={(e) => setagentid(e.target.value)}
                        sx={{ maxHeight: 20, marginRight: 10 }}
                        label="ID"
                        variant="outlined"
                        size="small" />
                    <TextField
                        id="outlined-basic"
                        value={agentname}
                        onChange={(e) => setagentname(e.target.value)}
                        sx={{ maxHeight: 25, marginRight: 10 }}
                        label="Name"
                        variant="outlined"
                        size="small" />
                    <FormControl sx={{ m: 1, minWidth: 200, marginRight: 10 }}>

                    </FormControl>
                    <Button variant="contained" onClick={() => searchagents()} sx={{ height: 40 }}>Search</Button>
                </div>
            </Container>
            <Container maxWidth="lg" className="containerwith" style={{ marginTop: 20 }}>
                {user.type !== 'Agent' && <Button onClick={() => setshowaddview(true)} variant="contained" startIcon={<FaPlus size={10} />} sx={{ height: 30, fontSize: 12 }}>Add User</Button>}
                <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                        <TableHead sx={{ backgroundColor: primarycolor }}>
                            <TableRow>
                                <TableCell sx={tableheadstyle} />
                                <TableCell sx={tableheadstyle}>ID </TableCell>
                                <TableCell sx={tableheadstyle} >Name</TableCell>
                                <TableCell sx={tableheadstyle} >Tel</TableCell>
                                <TableCell sx={tableheadstyle} >Email</TableCell>
                                <TableCell sx={tableheadstyle} >Status</TableCell>
                                <TableCell sx={tableheadstyle} >Last Login</TableCell>
                                <TableCell sx={tableheadstyle} >Create Time</TableCell>
                                <TableCell sx={tableheadstyle} >Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {displayedagents?.length > 0 && displayedagents?.map((row) => (
                                <TableRow
                                    key={row.id}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell><img src={row.profileurl} className="userminipic" /></TableCell>
                                    <TableCell sx={{ display: "flex", position: "relative" }}>{row.status == '1' ? <div className="availabledot" /> : <div className="notavailabledot" />} {row.id}</TableCell>
                                    <TableCell component="th" scope="row" sx={{ fontSize: 12 }}> {row.username}  </TableCell>
                                    <TableCell sx={{ fontSize: 12 }}>{row.phone}</TableCell>
                                    <TableCell sx={{ fontSize: 12 }}>{row.email}</TableCell>
                                    <TableCell sx={{ fontSize: 12 }}>{row.status == '1' ? 'Available' : 'Occupied'}</TableCell>
                                    <TableCell sx={{ fontSize: 10 }}>{row.lastlogin}</TableCell>
                                    <TableCell sx={{ fontSize: 10 }}>{new Date(row.created_at).toDateString()}</TableCell>
                                    <TableCell sx={{ fontSize: 10, cursor: "pointer" }}>
                                        <PopupState variant="popover" popupId="demo-popup-menu">
                                            {(popupState) => (
                                                <React.Fragment>
                                                    <MoreHorizOutlined {...bindTrigger(popupState)} />
                                                    <Menu {...bindMenu(popupState)}>
                                                        {user.type !== 'Agent' &&
                                                            <MenuItem sx={{ fontSize: 12 }} onClick={() => handleMenuItemClick(popupState, () => {
                                                                settempuser(row);
                                                                setshowdeleteuser(true);
                                                            })}> Delete user</MenuItem>}
                                                    </Menu>
                                                </React.Fragment>
                                            )}
                                        </PopupState>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Container>
        </div>
    )
}

export default Agents